var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import MainLayout from '../../layouts/MainLayout';
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import './index.scss';
import { getMetrics } from '../../services/widget-service';
import RefreshIcon from '../../assets/icons/refresh_right.svg';
import { getReportTypes, exportCSV, registerBigReportData, loadDefaultSetting } from '../../services/report-service';
import { getPresentationTypes } from "../../utils/ReportUtil";
import { sortArrayOfObjects, getCurrentUserDetails, getPublisherSelectedByCurrentUser, checkRoleUser, getCachedMultiplePublishers, notificationSimple } from "../../utils/CommonUtil";
import { userInfoData } from '../../store/authentication/reducer';
import { publisherData, getSelectedReportPublishersData, getDefaultSettingData, isSaveDefaultSettingSuccess } from '../../store/publisher/reducer';
import { buildParentFilter } from "../../utils/FilterUtil";
import { exportZipFile, exportEachCSV } from "../../utils/FileUtil";
import { exportPNGFromChart } from "../../utils/ChartUtil";
import * as Constant from "../../utils/Constant";
import { storeCurrentMenuItemPosition, storeCurrentParentMenuItemPosition } from '../../store/header/actions';
import { storeReportPublishers, updateDefaultSetting, resetDefaultViewStatus } from '../../store/publisher/actions';
import { DialogDefault as Dialog } from '../../components/common/dialog/Dialog';
import { getItem, LAST_REPORT_SETTING, storeItem } from '../../utils/LocalStorageUtil';
import PinIcon from '../../assets/icons/office-pin.svg';
import PinnedIcon from '../../assets/icons/office-pinned.svg';
var Loading = function () { return React.createElement("div", null, "Loading..."); };
var LazyReportSettingPanel = React.lazy(function () { return import('./components/ReportSettingPanel'); });
var ReportSettingPanel = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyReportSettingPanel, __assign({}, props)));
};
var LazyReportTypeWrapper = React.lazy(function () { return import('./components/ReportTypeWrapper'); });
var ReportTypeWrapper = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyReportTypeWrapper, __assign({}, props)));
};
var LazyReportGroupListing = React.lazy(function () { return import('./components/ReportGroupListing'); });
var ReportGroupListing = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyReportGroupListing, __assign({}, props)));
};
var ReportPage = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var _a = useState(getCurrentUserDetails()), currentUser = _a[0], setCurrentUser = _a[1];
    var _b = useState([]), metricList = _b[0], setMetricList = _b[1];
    var _c = useState([]), allReportTypes = _c[0], setAllReportTypes = _c[1];
    var _d = useState([]), selectedReportTypes = _d[0], setSelectedReportTypes = _d[1];
    var _e = useState([]), paramReportTypes = _e[0], setParamReportTypes = _e[1];
    var _f = useState(), publisherIds = _f[0], setPublisherIds = _f[1];
    var _g = useState(), selectedReportGroup = _g[0], setSelectedReportGroup = _g[1];
    var _h = useState(false), isEditingReportGroup = _h[0], setEditingReportGroup = _h[1];
    var _j = useState(true), isShowReportGroupPanel = _j[0], setShowReportGroupPanel = _j[1];
    var _k = useState(), settingData = _k[0], setSettingData = _k[1];
    var _l = useState(false), isResetReportSetting = _l[0], setResetReportSetting = _l[1];
    var _m = useState(false), isDownloadImage = _m[0], setDownloadImage = _m[1];
    var _o = useState(false), isLoadingExportCSV = _o[0], setLoadingExportData = _o[1];
    var _p = useState(), locationSettingDashboard = _p[0], setLocationSettingDashboard = _p[1];
    var _q = useState(false), isReadyReportType = _q[0], setReadyReportType = _q[1];
    var _r = useState(false), isLoadingData = _r[0], setLoadingData = _r[1];
    var _s = useState(false), isSavingAndRun = _s[0], setIsSavingAndRun = _s[1];
    var _t = useState([]), downloadImageReportTypes = _t[0], setDownloadImageReportTypes = _t[1];
    var _u = useState(null), downloadCSVReportTypes = _u[0], setDownloadCSVReportTypes = _u[1];
    var _v = useState(false), enableCheckedDownload = _v[0], setEnableCheckedDownload = _v[1];
    var _w = useState(false), isDownloadAllCSV = _w[0], setDownloadAllCSV = _w[1];
    var _isMounted = useRef(true);
    var _x = useState([]), publishers = _x[0], setPublishers = _x[1];
    var _y = useState(false), isEnableMultiplePublishers = _y[0], setEnableMultiplePublishers = _y[1];
    var _z = useState(null), defaultSetting = _z[0], setDefaultSetting = _z[1];
    var _0 = useState(false), isExistingDefaultSetting = _0[0], setExistingDefaultSetting = _0[1];
    var _1 = useState(false), openModal = _1[0], setOpenModal = _1[1];
    var _2 = useState(), defaultSettingRequest = _2[0], setDefaultSettingRequest = _2[1];
    var _3 = useState(false), isLoadingRegisterReportData = _3[0], setLoadingRegisterReportData = _3[1];
    var _4 = useState(false), isReportGroupDataChange = _4[0], setReportGroupDataChange = _4[1];
    var _5 = useState([]), sortMedias = _5[0], setSortMedias = _5[1];
    var _6 = useState([]), sortPlatforms = _6[0], setSortPlatforms = _6[1];
    var _7 = useState([]), sortInventories = _7[0], setSortInventories = _7[1];
    var _8 = useState([]), sortPlatformInventories = _8[0], setSortPlatformInventories = _8[1];
    var _9 = useState([]), sortSubPlatformGroups = _9[0], setSortSubPlatformGroups = _9[1];
    var _10 = useState([]), sortPlatformGroups = _10[0], setSortPlatformGroups = _10[1];
    var _11 = useState(), lastSetting = _11[0], setLastSetting = _11[1];
    var _12 = useState(false), isLoadingDownloadImage = _12[0], setLoadingDownloadImage = _12[1];
    var _13 = useState(true), showUpPanel = _13[0], setShowUpPanel = _13[1];
    var _14 = useState(false), isHoverPanel = _14[0], setIsHoverPanel = _14[1];
    var refForceLoadData = useRef(null);
    var _15 = useState(null), previusDuration = _15[0], setPreviusDuration = _15[1];
    var _16 = useState(false), isValidDuration = _16[0], setIsValidDuration = _16[1];
    useEffect(function () {
        document.title = t("page.report") + Constant.APP_NAME;
        handleCheckPlatformGroup();
        getMetricList();
        getReportTypesByUser();
        props.dispatch(storeCurrentMenuItemPosition({ position: 1 }));
        props.dispatch(storeCurrentParentMenuItemPosition({ position: 0 }));
        loadLastReportSettingFromCache();
        handleCountTimeHiddenPanel();
        return (function () {
            _isMounted.current = false;
            props.dispatch(storeReportPublishers(null));
            props.dispatch(resetDefaultViewStatus());
        });
    }, []);
    useEffect(function () {
        if (props.publisherData) {
            var isSamePublishers = _.isEqual(props.publisherData, publishers);
            if (!isSamePublishers) {
                setSelectedReportTypes([]);
                setPublishers(props.publisherData);
                checkEnabledMultiplePublishers(props.publisherData);
                setSelectedReportGroup(null);
            }
        }
    }, [props.publisherData]);
    useEffect(function () {
        if (props.reportPublishers && props.reportPublishers.length) {
            setSelectedReportTypes([]);
            setDownloadImageReportTypes([]);
            setSelectedReportGroup(null);
            var selectedPublisherIds = props.reportPublishers.map(function (publisher) {
                if (publisher) {
                    return publisher.id;
                }
            });
            setPublisherIds(selectedPublisherIds);
        }
    }, [props.reportPublishers]);
    useEffect(function () {
        if (props.userInfoData) {
            setCurrentUser(props.userInfoData);
        }
    }, [props.userInfoData]);
    useEffect(function () {
        if (props.isSaveDefaultSettingSuccess) {
            notificationSimple('Save Default Setting Success', Constant.NOTIFICATION_SUCCESS);
        }
    }, [props.isSaveDefaultSettingSuccess]);
    var handleCountTimeHiddenPanel = function () {
        // setTimeout(() => setShowUpPanel(false), 3000);
    };
    var checkEnabledMultiplePublishers = function (publishers) {
        if (publishers && publishers.length) {
            var isMultiplePublishers = false;
            var enabledPublisher = publishers.find(function (publisher) { return publisher && publisher.enabledMultiplePublishers; });
            isMultiplePublishers = enabledPublisher ? true : false;
            setEnableMultiplePublishers(isMultiplePublishers);
            getPublishers(isMultiplePublishers, publishers);
        }
        else {
            setEnableMultiplePublishers(false);
            getPublishers(false, publishers);
        }
    };
    var handleCheckPlatformGroup = function () {
        var location = props.location;
        if (location && location.state) {
            setLocationSettingDashboard(location.state);
        }
    };
    var getPublishers = function (isEnableMultiplePublishers, publishers) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedPublishers, selectedPublisherIds_1, currentPublisher;
        return __generator(this, function (_a) {
            if (isEnableMultiplePublishers) {
                selectedPublishers = getCachedMultiplePublishers();
                selectedPublisherIds_1 = [];
                if (selectedPublishers && selectedPublishers.length) {
                    selectedPublishers.forEach(function (publisher) {
                        if (publisher) {
                            selectedPublisherIds_1.push(publisher.id);
                        }
                    });
                    setPublisherIds(selectedPublisherIds_1);
                }
                else {
                    if (publishers && publishers.length && publishers[0]) {
                        setPublisherIds([publishers[0].id]);
                    }
                }
            }
            else {
                currentPublisher = getPublisherSelectedByCurrentUser();
                if (currentPublisher) {
                    setPublisherIds([currentPublisher.id]);
                }
                else {
                    if (publishers && publishers.length && publishers[0]) {
                        setPublisherIds([publishers[0].id]);
                    }
                }
            }
            return [2 /*return*/];
        });
    }); };
    var getMetricList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metrics, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMetrics()];
                case 1:
                    metrics = _a.sent();
                    if (_isMounted.current) {
                        setMetricList(metrics);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error Metric", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getReportTypesByUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, reportTypes, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {};
                    if (selectedReportGroup && selectedReportGroup.id) {
                        params.reportGroupIds = selectedReportGroup.id;
                    }
                    return [4 /*yield*/, getReportTypes(params)];
                case 1:
                    reportTypes = _a.sent();
                    if (_isMounted.current) {
                        setAllReportTypes(reportTypes);
                        setReadyReportType(true);
                    }
                    handleReportTypes(reportTypes);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("getReportTypes", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleReportTypes = function (allReportTypes) {
        var reportTypes = allReportTypes.filter(function (reportType) {
            return (reportType.status === 'ACTIVE' && reportType.reportGroup != null
                && selectedReportGroup && reportType.reportGroup.id === selectedReportGroup.id);
        });
        if (!reportTypes || !reportTypes.length) {
            setLoadingData(false);
            setIsSavingAndRun(false);
            return;
        }
        // const sortedReportTypes = sortReportTypes(reportTypes);
        var sortedReportTypes = _.sortBy(reportTypes, "displayOrder");
        for (var i = 0; i < sortedReportTypes.length; i++) {
            var activeReportTypeMetrics = sortedReportTypes[i].reportTypeMetrics.filter(function (reportTypeMetric) {
                return reportTypeMetric.status === 'ACTIVE';
            });
            sortedReportTypes[i].metrics = activeReportTypeMetrics.map(function (reportTypeMetric) {
                return __assign(__assign(__assign({}, reportTypeMetric.advertisingMetric), reportTypeMetric), { collectionField: reportTypeMetric.advertisingMetric.defaultCollectionField });
            });
            sortArrayOfObjects(sortedReportTypes[i].metrics, 'displayOrder');
        }
        var downloadImageReportTypesTemp = [];
        sortedReportTypes.map(function (reportType) {
            reportType.isLoading = true;
            if (reportType.presentationType != Constant.PRESENTATION_TYPE_TABLE && reportType.presentationType != Constant.PRESENTATION_TYPE_SUMMARY) {
                downloadImageReportTypesTemp.push(__assign(__assign({}, reportType), { file: null }));
            }
        });
        var listCSVReportTypes = (sortedReportTypes || []).filter(function (reportType) { return reportType.presentationType == Constant.PRESENTATION_TYPE_TABLE; });
        if (listCSVReportTypes && listCSVReportTypes.length) {
            var downloadCSV = {};
            (listCSVReportTypes || []).forEach(function (reportType) {
                downloadCSV[reportType.id] = false;
            });
            setEnableCheckedDownload(false);
            setDownloadCSVReportTypes(downloadCSV);
        }
        else {
            setEnableCheckedDownload(false);
        }
        setDownloadImageReportTypes(downloadImageReportTypesTemp);
        setSelectedReportTypes(sortedReportTypes);
    };
    var sortReportTypes = function (reportTypes) {
        var presentationTypes = getPresentationTypes();
        var sortingReportTypes = reportTypes.slice();
        sortingReportTypes.sort(function (a, b) {
            var aPresentationType = presentationTypes.find(function (presentationType) { return presentationType.name === a.presentationType; });
            var bPresentationType = presentationTypes.find(function (presentationType) { return presentationType.name === b.presentationType; });
            var aDisplayOrder = (aPresentationType === null || aPresentationType === void 0 ? void 0 : aPresentationType.displayOrder) || 0;
            var bDisplayOrder = (bPresentationType === null || bPresentationType === void 0 ? void 0 : bPresentationType.displayOrder) || 0;
            if (aDisplayOrder === bDisplayOrder) {
                return a.name.localeCompare(b.name);
            }
            else {
                return aDisplayOrder - bDisplayOrder;
            }
        });
        return sortingReportTypes;
    };
    var onShowReportGroupPanel = function () {
        setShowReportGroupPanel(!isShowReportGroupPanel);
    };
    var onEditReportGroup = function (isEditing) {
        setEditingReportGroup(isEditing);
    };
    var onReportGroupChanged = function (reportGroup) {
        if (!reportGroup)
            return;
        setSelectedReportTypes([]);
        setDownloadImageReportTypes([]);
        setReportGroupDataChange(false);
        setEnableCheckedDownload(false);
        setDownloadCSVReportTypes(null);
        setSelectedReportGroup(reportGroup);
        setPreviusDuration(null);
        setIsValidDuration(false);
        if (!publisherIds || !publisherIds.length || publisherIds.length > 1)
            return;
        // get Default Setting by Report Group
        loadDefaultSettingByReportGroup(publisherIds[0], reportGroup);
    };
    var loadDefaultSettingByReportGroup = function (publisherId, reportGroup) { return __awaiter(void 0, void 0, void 0, function () {
        var defaultSettingData, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!reportGroup) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadDefaultSetting(publisherId, reportGroup.id)];
                case 2:
                    defaultSettingData = _a.sent();
                    if (_isMounted.current) {
                        if (defaultSettingData && defaultSettingData.publisherId) {
                            setExistingDefaultSetting(true);
                            setDefaultSetting(defaultSettingData);
                        }
                        else {
                            setDefaultSetting(null);
                            setExistingDefaultSetting(false);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error("Error loadDefaultSetting", error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onLoadReportData = function (data, doLoading) {
        if (!isLoadingData) {
            setSelectedReportTypes([]);
            setParamReportTypes([]);
            setShowReportGroupPanel(false);
            setReadyReportType(false);
            if (doLoading) {
                setLoadingData(true);
            }
            setSettingData(data);
            setEnableCheckedDownload(false);
            setDownloadCSVReportTypes(null);
            getReportTypesByUser();
        }
    };
    var checkEnableReport = function () {
        if (currentUser && currentUser.type == "INTERNAL") {
            return true;
        }
        if (currentUser && currentUser.type === "EXTERNAL" && checkRoleUser(Constant.ROLE_ADMIN) || checkRoleUser(Constant.ROLE_MEDIA_MEMBER)) {
            return true;
        }
        return false;
    };
    var onClickDownloadCSV = function () { return __awaiter(void 0, void 0, void 0, function () {
        var csvReportTypeList, params, files, fileDataList, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!paramReportTypes || !paramReportTypes.length || isLoadingExportCSV || !enableCheckedDownload)
                        return [2 /*return*/];
                    if (!downloadCSVReportTypes) return [3 /*break*/, 5];
                    csvReportTypeList = (paramReportTypes || []).filter(function (reportType) {
                        var foundReportType = Object.keys(downloadCSVReportTypes).find(function (csvReportType) { return csvReportType == reportType.reportTypeId; });
                        if (foundReportType && downloadCSVReportTypes[foundReportType])
                            return true;
                        return false;
                    });
                    if (!(csvReportTypeList && csvReportTypeList.length)) return [3 /*break*/, 4];
                    setLoadingExportData(true);
                    params = buildCSVParams(csvReportTypeList);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, exportCSV(params)];
                case 2:
                    files = _a.sent();
                    fileDataList = files.map(function (file) {
                        return {
                            name: "" + file.reportTypeName,
                            fileData: file.data
                        };
                    });
                    exportEachCSV(fileDataList);
                    setLoadingExportData(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    setLoadingExportData(false);
                    console.error('fetchReportData:', error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClickDownloadImage = function (value) {
        if (!checkHaveChart() || !enableDownloadImage()) {
            setLoadingDownloadImage(false);
            return;
        }
        ;
        if (checkHaveChart() && !isLoadingDownloadImage) {
            setLoadingDownloadImage(true);
            setDownloadImage(value);
        }
    };
    var onChangeDownloadImage = function (reportType) {
        setDownloadImage(false);
        var foundIndexReportType = downloadImageReportTypes.findIndex(function (downloadImageReportType) { return downloadImageReportType.id == reportType.id; });
        if (foundIndexReportType > -1) {
            downloadImageReportTypes[foundIndexReportType] = reportType;
        }
        var foundFile = downloadImageReportTypes.find(function (downloadImageReportType) { return downloadImageReportType.file; });
        if (foundFile) {
            if (downloadImageReportTypes.length > 1) {
                var filesNotImage = downloadImageReportTypes.filter(function (fileDownload) { return fileDownload.isNotImage; });
                var files = downloadImageReportTypes.reduce(function (fileDownloads, currentValue) {
                    if (currentValue.file) {
                        var fileTemps = currentValue.file.split("image/png;base64,");
                        fileDownloads.push({
                            name: currentValue.name + ".png",
                            fileData: fileTemps[1]
                        });
                    }
                    return fileDownloads;
                }, []);
                var countFilesDownload = downloadImageReportTypes.length - filesNotImage.length;
                if (countFilesDownload == files.length) {
                    var callbackSuccessZipFile = function () {
                        console.log("close loading success zip file");
                        setLoadingDownloadImage(false);
                        var newImageReportTypes = downloadImageReportTypes.map(function (item) {
                            delete (item.isNotImage);
                            return __assign(__assign({}, item), { file: null });
                        });
                        setDownloadImageReportTypes(newImageReportTypes);
                    };
                    exportZipFile(files, "image_chart", "IMAGE", callbackSuccessZipFile);
                }
            }
            else {
                var _a = downloadImageReportTypes[0], name_1 = _a.name, file = _a.file;
                exportPNGFromChart(file, name_1 + ".png");
                setLoadingDownloadImage(false);
                var newImageReportTypes = downloadImageReportTypes.map(function (item) {
                    return __assign(__assign({}, item), { file: null });
                });
                setDownloadImageReportTypes(newImageReportTypes);
            }
        }
        else {
            setLoadingDownloadImage(false);
        }
    };
    var buildCSVParams = function (csvReportTypeList) {
        var params = {
            publisherIds: settingData.publisherIds,
            fromDate: moment(settingData.duration.startDate).format('YYYYMMDD'),
            toDate: moment(settingData.duration.endDate).format('YYYYMMDD'),
            timeSegment: settingData.timeSegment,
            displayDashboard: currentUser && currentUser.type === 'EXTERNAL' ? 'PUBLISHER' : 'MASTER',
            parentFilters: JSON.stringify(buildParentFilter(settingData))
        };
        params.exportCsvReportDetailForms = csvReportTypeList.map(function (param) {
            var paramExport = {
                reportTypeId: param.reportTypeId,
                filters: param.filters ? JSON.stringify(param.filters) : "",
                managedByEnhance: param.managedByEnhance
            };
            if (param && param.hasOwnProperty("hidePublisherRevenueZero")) {
                paramExport["hidePublisherRevenueZero"] = param.hidePublisherRevenueZero;
            }
            if (param["sorts"]) {
                paramExport["sorts"] = param["sorts"];
            }
            return paramExport;
        });
        return params;
    };
    var onChangeParams = function (paramReportType) {
        if (!paramReportType)
            return;
        var reportTypes = paramReportTypes;
        var foundIndex = (reportTypes || []).findIndex(function (reportType) { return reportType.reportTypeId == paramReportType.reportTypeId; });
        if (foundIndex > -1) {
            reportTypes.splice(foundIndex, 1, paramReportType);
        }
        else {
            reportTypes.push(paramReportType);
        }
        setParamReportTypes(reportTypes);
    };
    var onClickCloneReport = function () {
        if (!checkEnableReport())
            return;
        var location = {
            pathname: "report-builder/" + selectedReportGroup.id + "/clone",
            state: selectedReportGroup
        };
        history.push(location);
    };
    var onClickEditReport = function () {
        if (!checkEnableReport())
            return;
        var location = {
            pathname: "report-builder/" + selectedReportGroup.id + "/edit",
            state: selectedReportGroup
        };
        history.push(location);
    };
    var onClickCreateReport = function () {
        var location = {
            pathname: "report-builder/create",
        };
        history.push(location);
    };
    var checkHaveChart = function () {
        var foundChart = selectedReportTypes.find(function (reportType) { return reportType.presentationType.indexOf("CHART") > -1; });
        if (foundChart)
            return true;
        return false;
    };
    var enableDownloadImage = function () {
        return downloadImageReportTypes && downloadImageReportTypes.length;
    };
    var onChangeLoadingReportType = function (indexReportType) {
        if (!selectedReportTypes || !selectedReportTypes.length)
            return;
        var selectedReportTypeData = __spreadArrays(selectedReportTypes);
        selectedReportTypeData[indexReportType].isLoading = false;
        var foundLoading = selectedReportTypeData.find(function (item) { return item.isLoading; });
        if (!foundLoading) {
            setLoadingData(false);
            setIsSavingAndRun(false);
        }
        setSelectedReportTypes(selectedReportTypeData);
    };
    var onCheckDownloadCSV = function (isCheck, reportTypeData) {
        downloadCSVReportTypes[reportTypeData.id] = isCheck;
        var foundCheckedCSV = Object.keys(downloadCSVReportTypes).find(function (reportType) { return downloadCSVReportTypes[reportType]; });
        if (foundCheckedCSV) {
            setEnableCheckedDownload(true);
        }
        else {
            setEnableCheckedDownload(false);
        }
        var isCheckAll = true;
        Object.keys(downloadCSVReportTypes).forEach(function (idReportType) {
            if (!downloadCSVReportTypes[idReportType]) {
                isCheckAll = false;
            }
        });
        setDownloadAllCSV(isCheckAll);
        setDownloadCSVReportTypes(downloadCSVReportTypes);
    };
    var onChangeDownloadAllCSV = function (event) {
        var downloadCSVReportTypeList = {};
        selectedReportTypes.forEach(function (reportType) {
            if (reportType.presentationType == Constant.PRESENTATION_TYPE_TABLE) {
                downloadCSVReportTypeList[reportType.id] = event.currentTarget.checked ? true : false;
            }
        });
        var foundCheckedCSV = Object.keys(downloadCSVReportTypeList).find(function (reportType) { return downloadCSVReportTypeList[reportType]; });
        if (foundCheckedCSV) {
            setEnableCheckedDownload(true);
        }
        else {
            setEnableCheckedDownload(false);
        }
        setDownloadCSVReportTypes(Object.keys(downloadCSVReportTypeList).length ? downloadCSVReportTypeList : null);
        setDownloadAllCSV(event.currentTarget.checked);
    };
    var onClickResetPage = function () {
        setSettingData(null);
        setSelectedReportTypes([]);
        setDownloadImageReportTypes([]);
        setResetReportSetting(true);
    };
    var onClickSaveDefaultSetting = function (defaultSettingData, forceLoadData) {
        if (!defaultSettingData)
            return;
        if (!publisherIds || publisherIds.length > 1)
            return;
        if (isExistingDefaultSetting) {
            setDefaultSettingRequest(defaultSettingData);
            setOpenModal(true);
        }
        else {
            saveDefautlSetting(defaultSettingData);
        }
        refForceLoadData.current = forceLoadData;
    };
    var handleClose = function () {
        setOpenModal(false);
    };
    var onSaveDefaultSetting = function () {
        saveDefautlSetting(defaultSettingRequest);
        setOpenModal(false);
        if (refForceLoadData.current) {
            setIsSavingAndRun(true);
            refForceLoadData.current();
        }
    };
    var saveDefautlSetting = function (defaultData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            props.dispatch(updateDefaultSetting(defaultData));
            return [2 /*return*/];
        });
    }); };
    var onQueueBigReport = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var body, result, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingRegisterReportData(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = data;
                    body.reportGroupId = selectedReportGroup.id;
                    body.selectedReportTypeIds = [];
                    return [4 /*yield*/, registerBigReportData(body)];
                case 2:
                    result = _a.sent();
                    setPreviusDuration({ fromDate: data.fromDate, toDate: data.toDate });
                    notificationSimple("Queue Report Success!", Constant.NOTIFICATION_SUCCESS);
                    setReportGroupDataChange(true);
                    setLoadingRegisterReportData(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.log("Error Queue Report ::");
                    setLoadingRegisterReportData(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeSortData = function (type, data) {
        switch (type) {
            case "MEDIA":
                setSortMedias(data);
                break;
            case "PLATFORM":
                setSortPlatforms(data);
                break;
            case "PUBDESK_INVENTORY":
                setSortInventories(data);
                break;
            case "PLATFORM_INVENTORY":
                setSortPlatformInventories(data);
                break;
            case "SUBPLATFORM_GROUP":
                setSortSubPlatformGroups(data);
                break;
            case "PLATFORM_GROUP":
                setSortPlatformGroups(data);
                break;
        }
        ;
    };
    var onStoreLastSetting = function (requestData) {
        var lastSettingStoreData = {
            reportGroupId: selectedReportGroup.id,
            publisherIds: publisherIds
        };
        if (requestData) {
            lastSettingStoreData = __assign(__assign({}, lastSettingStoreData), requestData);
        }
        setLastSetting(function (prevState) { return (__assign(__assign({}, prevState), lastSettingStoreData)); });
        storeItem(LAST_REPORT_SETTING, JSON.stringify(lastSettingStoreData));
    };
    var loadLastReportSettingFromCache = function () {
        var cachedLastSettingJson = getItem(LAST_REPORT_SETTING);
        if (cachedLastSettingJson) {
            var cachedLastSetting = JSON.parse(cachedLastSettingJson);
            if (cachedLastSetting) {
                setLastSetting(cachedLastSetting);
            }
        }
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "report-container" },
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12, sm: 2 },
                    React.createElement("div", { className: "top-page-section" },
                        React.createElement("div", { className: "page-title" }, t("report.title"))),
                    React.createElement("div", { className: "report-setting-wrapper" },
                        React.createElement(ReportSettingPanel, { publisherIds: publisherIds, locationSettingDashboard: locationSettingDashboard, onLoadReportData: function (data, doLoading) { return onLoadReportData(data, doLoading); }, isShowLoadDataButton: true, isReportGroupSelected: selectedReportGroup && selectedReportGroup.status == 'ACTIVE' ? true : false, isResetSetting: isResetReportSetting, isReadyReportType: isReadyReportType, isLoadingData: isLoadingData, isSavingAndRun: isSavingAndRun, isAllPlatform: true, isAllMedia: true, isAllPubdeskInventory: true, onResetSettingSuccess: function () { return setResetReportSetting(false); }, onSaveDefaultSetting: function (settingData, forceLoadData) { return onClickSaveDefaultSetting(settingData, forceLoadData); }, selectedReportGroup: selectedReportGroup, defaultSetting: defaultSetting, isReportGroupDataChange: isReportGroupDataChange, isLoadingRegisterReportData: isLoadingRegisterReportData, onQueueBigReport: function (data) { return onQueueBigReport(data); }, onChangeSortData: onChangeSortData, lastSetting: lastSetting, onStoreLastSetting: function (data) { return onStoreLastSetting(data); }, previusDuration: previusDuration, isValidDuration: isValidDuration, setIsValidDuration: setIsValidDuration, isShowSaveDefaultView: true }))),
                React.createElement(Grid, { item: true, xs: 12, sm: isShowReportGroupPanel ? 8 : 10, className: "report-main-content" },
                    React.createElement("div", { className: "control-report-container" },
                        React.createElement("div", { className: "btn-reset", onClick: onClickResetPage },
                            React.createElement("img", { src: RefreshIcon, alt: "ic-reset" }),
                            React.createElement("div", null, t('common.reset'))),
                        selectedReportTypes && selectedReportTypes.length && downloadCSVReportTypes ?
                            React.createElement("label", { className: "checkbox-all-report" },
                                React.createElement("input", { type: "checkbox", checked: isDownloadAllCSV, onChange: onChangeDownloadAllCSV }),
                                React.createElement("span", { className: "checkmark-all" }),
                                React.createElement("span", null, t('report.all_csv_download'))) : null),
                    React.createElement("div", { className: "report-group-input" },
                        selectedReportGroup ? React.createElement("div", { className: "report-group-name" }, selectedReportGroup.name) :
                            React.createElement("div", { className: "placeholder" }, t('report.report_selection_placeholder')),
                        React.createElement("div", { className: "btn-open-report-group-list", onClick: onShowReportGroupPanel }, t('report.report_selection'))),
                    React.createElement("div", { className: "report-types-wrapper" }, selectedReportTypes && selectedReportTypes.length ?
                        selectedReportTypes.map(function (item, index) {
                            return (React.createElement("div", { className: "report-type-wrapper", key: index },
                                React.createElement(ReportTypeWrapper, { reportTypeData: item, onChangeParams: onChangeParams, downloadImage: isDownloadImage, downloadImageCharts: downloadImageReportTypes, onChangeDownloadImage: onChangeDownloadImage, presentationType: item.presentationType, settingData: settingData, onChangeLoadingReportType: function () { return onChangeLoadingReportType(index); }, isCheckDownloadCSV: downloadCSVReportTypes && downloadCSVReportTypes[item.id] ? true : false, onCheckDownloadCSV: function (isCheck) { return onCheckDownloadCSV(isCheck, item); }, sortMedias: sortMedias, sortInventories: sortInventories, sortPlatforms: sortPlatforms, sortPlatformInventories: sortPlatformInventories, sortSubPlatformGroups: sortSubPlatformGroups, sortPlatformGroups: sortPlatformGroups })));
                        })
                        : null)),
                React.createElement(Grid, { item: true, xs: 12, sm: isEditingReportGroup ? 3 : 2, className: "report-group-wrapper" + (isShowReportGroupPanel ? '' : ' hidden-panel') },
                    React.createElement(ReportGroupListing, { publisherIds: publisherIds, reportGroupId: locationSettingDashboard && locationSettingDashboard.reportGroupId ? locationSettingDashboard.reportGroupId : null, onEditingReportGroup: function (isEditing) { return onEditReportGroup(isEditing); }, onReportGroupChanged: function (reportGroup) { return onReportGroupChanged(reportGroup); }, isEnableMultiplePublishers: isEnableMultiplePublishers }))),
            isEditingReportGroup ? React.createElement("div", { className: "bg-opacity-edit-mode" }) : null,
            React.createElement(Grid, { container: true, className: isHoverPanel || showUpPanel ? "fixed-bottom-panel" : "fixed-bottom-panel-hidden", onMouseEnter: function () { return setIsHoverPanel(true); }, onMouseLeave: function () { return setIsHoverPanel(false); } },
                React.createElement(Grid, { item: true, xs: 12, sm: 12, className: isHoverPanel || showUpPanel ? "bottom-panel-container" : "bottom-panel-container-hidden" },
                    React.createElement("div", { className: "left-bottom" },
                        React.createElement("button", { className: "btn-pb-primary-2 btn-download-csv " + (!paramReportTypes || !paramReportTypes.length || isLoadingExportCSV || !enableCheckedDownload ? "disabled" : ""), type: "button", onClick: onClickDownloadCSV, disabled: !paramReportTypes || !paramReportTypes.length || isLoadingExportCSV || !enableCheckedDownload ? true : false },
                            t('report.download_csv'),
                            isLoadingExportCSV ? React.createElement(CircularProgress, { size: 20 }) : null),
                        React.createElement("button", { className: "btn-pb-primary-2 " + (!checkHaveChart() || !enableDownloadImage() || isLoadingDownloadImage || isLoadingData ? "disabled" : ""), type: "button", onClick: function () { return onClickDownloadImage(true); }, disabled: !enableDownloadImage() || isLoadingDownloadImage || isLoadingData ? true : false },
                            t('report.download_image'),
                            isLoadingDownloadImage ? React.createElement(CircularProgress, { size: 20 }) : null)),
                    React.createElement("div", { className: "right-bottom" },
                        checkEnableReport() ? React.createElement("button", { className: "btn-pb-primary-2 btn-clone-report", type: "button", disabled: false, onClick: onClickCreateReport }, t("report.new_addition")) : null,
                        React.createElement("button", { className: "btn-pb-primary-2 btn-clone-report " + (!selectedReportGroup || !checkEnableReport() ? "disabled" : ""), type: "button", onClick: onClickCloneReport, disabled: false }, t('report.clone_report')),
                        React.createElement("button", { className: "btn-pb-primary-2 " + (!selectedReportGroup || !checkEnableReport() ? "disabled" : ""), type: "button", onClick: onClickEditReport, disabled: false }, t('report.edit_report')),
                        React.createElement("img", { src: showUpPanel ? PinIcon : PinnedIcon, alt: "ic-pinned", className: "pinned-icon", onClick: function () { return showUpPanel ? setShowUpPanel(false) : setShowUpPanel(true); } })))),
            React.createElement(Dialog, { open: openModal, handleClose: handleClose, title: "A default filter is exist, do you want to save changes to the default filter?", onSave: onSaveDefaultSetting, actionName: t("common.save") }))));
};
function mapStateToProps(state) {
    return {
        userInfoData: userInfoData(state),
        publisherData: publisherData(state),
        reportPublishers: getSelectedReportPublishersData(state),
        defaultSettingData: getDefaultSettingData(state),
        isSaveDefaultSettingSuccess: isSaveDefaultSettingSuccess(state)
    };
}
export default connect(mapStateToProps)(ReportPage);
